'use client'

import '../../pages/style.css'
import { type ReactNode } from 'react'
import { usePathname } from 'lib/i18n/routing'
import Globals from './component'
import PostHogProviderAppRouter from 'components/posthog-provider/app-router'
import { LocaleProvider } from '@web/utils/i18n/helpers'
import { useLocale } from 'next-intl'

interface Props {
	children: ReactNode
}

export default function AppGlobals({ children }: Props) {
	const pathname = usePathname()
	const locale = useLocale()

	return (
		<PostHogProviderAppRouter>
			<LocaleProvider locale={locale}>
				<Globals pathname={pathname}>{children}</Globals>
			</LocaleProvider>
		</PostHogProviderAppRouter>
	)
}
